import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { CircleWarningIcon, Typography } from '@chilecompra/react-kit/components'
import { formatTypeCurrency } from '../../modules/utils/formatTypeCurrency'
import { Row, Strong } from './SelectOfferDialog.styles'

/**
 * The SelectOfferDialogHeader's component.
 */
const SelectOfferDialogHeader = props => {
  const { currency, isOfferLowerPrice, offerSelected, offerCounter } = props

  const textSpecifiedLaw =
    'en la ficha de esta Compra Ágil y en la Orden de Compra de acuerdo con lo establecido en el numeral 1, literal d), del artículo 7, de la Ley N°19.886'

  const calculateTotalAmount = () => {
    const totalAmountSelectedOffer = offerSelected.map(
      offer => `${formatTypeCurrency(currency, offer.amount.replace(/,/g, ''), true)} `
    )
    if (totalAmountSelectedOffer.length > 1) {
      return totalAmountSelectedOffer.reduce((a, b) => a + b)
    }

    return totalAmountSelectedOffer
  }

  const totalAmount = () => {
    if (isOfferLowerPrice || offerCounter > 1) {
      const amountTotalFormatted = calculateTotalAmount()

      return `MONTO TOTAL ${amountTotalFormatted}`
    }
  }

  const textHeaderDialog = useMemo(() => {
    if (offerCounter > 1) {
      return ' Se emitirán las órdenes de compra a los proveedores seleccionados '
    }
    if (isOfferLowerPrice) {
      const businessName = offerSelected.map(item => item.businessName).join()
      return 'Se emitirá la orden de compra para el proveedor ' + businessName
    }
    return ' Hemos detectado que no has seleccionado al proveedor con el precio más bajo. '
  }, [isOfferLowerPrice])

  const textCaptionDialog = useMemo(() => {
    if (offerCounter > 1) {
      return 'Antes de finalizar, cuéntanos el criterio que ocupaste para seleccionar a estos proveedores.'
    }
    if (!isOfferLowerPrice) {
      return `Antes de continuar, cuéntanos el criterio que utilizaste para seleccionar esta cotización que no posee el precio más bajo.`
    }
  }, [offerCounter])

  return (
    <>
      <Row margin="10px 0 0">
        {!isOfferLowerPrice && offerCounter === 1 && <CircleWarningIcon fontSize="large" />}
        <Typography color="black1" fontSize="18px" fontWeight="bold" lineHeight="22px" variant="h4" padding="0 46px">
          {textHeaderDialog}
        </Typography>
        <Typography
          color="black3"
          fontSize="12px"
          fontWeight="bold"
          lineHeight="16px"
          margin="10px 0 0"
          variant="caption"
        >
          {totalAmount()}
        </Typography>
      </Row>
      <Row margin="10px 0 0">
        <Typography color="black2" fontSize="14px" lineHeight="18px" variant="body2">
          {textCaptionDialog}
          {!isOfferLowerPrice && <Strong> Esta información será visible públicamente </Strong>}
          {!isOfferLowerPrice && textSpecifiedLaw}
        </Typography>
      </Row>
    </>
  )
}

SelectOfferDialogHeader.defaultProps = {
  currency: 'CLP'
}

SelectOfferDialogHeader.propTypes = {
  currency: PropTypes.string,
  isOfferLowerPrice: PropTypes.bool.isRequired,
  offerSelected: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.string.isRequired,
      businessName: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired
    })
  ).isRequired,
  offerCounter: PropTypes.number.isRequired
}

export default SelectOfferDialogHeader
